import React, { useContext } from 'react'
import { Button } from 'reactstrap'
import { store } from '../../stores/uploads'

const UploadMultiSelectButton = () => {
  const { uploadMenuState, selectedItems } = useContext(store)

  const uploadsCount = selectedItems.filter(item => item.type === 'upload').length
  const graphicsCount = selectedItems.filter(item => item.type === 'graphic').length

  const uploadsText = uploadsCount > 0 ? `${uploadsCount} Upload${uploadsCount > 1 ? 's' : ''}` : ''
  const graphicsText = graphicsCount > 0 ? `${graphicsCount} Graphic${graphicsCount > 1 ? 's' : ''}` : ''

  const selectedText = `Select ${uploadsText} ${uploadsText && graphicsText ? 'and' : ''} ${graphicsText}`

  const handleClick = () => {
    uploadMenuState.onSelectUpload(selectedItems)
  }

  return uploadMenuState?.multi && (
    <div className="upload-select-multi-container">
      {selectedItems.length > 0 ? (
        <Button size="lg" color="primary" className="w-100 upload-select-multi" onClick={handleClick}>{selectedText}</Button>
      ) : (
        <Button size="lg" color="primary" disabled={true} className="w-100 upload-select-multi">No items selected</Button>
      )}
    </div>
  );
};

export default UploadMultiSelectButton;
